import { useCallback } from 'react';
import { useOpenThirdPartyWidgetEvent } from './useOpenThirdPartyWidgetEvent';
import { handleDialThirdParty } from '../utils/handleDialThirdParty';
import { useOpenCloseRemote } from './useOpenCloseRemote';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { useOpenWidgetDataContext } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { openManagePropertiesPage } from '../utils/openManagePropertiesPage';
// Handle open widget event for remote only config
export const useOpenRemoteFromDialer = ({
  ownerId
}) => {
  const {
    selectedCallProviderData
  } = useSelectedProviderContext();
  const {
    openRemote,
    closeRemote,
    setHasThirdPartyOpened
  } = useOpenCloseRemote();
  const {
    updateOpenWidgetDataForRemote
  } = useOpenWidgetDataContext();
  const handleOpenRemoteAndSendDialNumber = useCallback(payload => {
    if (payload !== null && payload !== void 0 && payload.addPhoneNumber && payload !== null && payload !== void 0 && payload.toSubject) {
      const {
        objectTypeId,
        objectId
      } = payload.toSubject;
      openManagePropertiesPage({
        objectTypeId,
        objectId
      });
      closeRemote();
      return;
    }
    setHasThirdPartyOpened(true);
    openRemote();
    handleDialThirdParty({
      openWidgetEvent: payload,
      ownerId,
      dialNumberProcessors: [updateOpenWidgetDataForRemote]
    });
  }, [openRemote, ownerId, setHasThirdPartyOpened, updateOpenWidgetDataForRemote, closeRemote]);
  useOpenThirdPartyWidgetEvent(selectedCallProviderData, handleOpenRemoteAndSendDialNumber, () => closeRemote());
};